import classNames from "classnames";
import moment from "moment";
import React, { useMemo } from "react";
import {
  Modal,
  Spinner,
} from 'reactstrap';
import { useRecoilState, } from 'recoil';
import {
  Button,
  Icon,
  Loading,
} from "../../components/Component";
import { getConfig } from "../../config";
import { useUser } from "../../context/user";
import ExchangeMoneyBetweenAccounts from '../../pages/bankaccountmanager/ExchangeMoneyBetweenAccounts';
import AddCustomerMoneyFlow from '../../pages/customermanager/AddCustomerMoneyFlow';
import PNAddCustomerMoneyFlow from '../../pages/pn/PNAddCustomerMoneyFlowComponent/PNAddCustomerMoneyFlow';
import PNUpsertTransactionHistory from "../../pages/pn/PNUpsertTransactionHistory";
import UpsertTransactionHistory from '../../pages/transactionhistorymanager/UpsertTransactionHistory';
import {
  popupCustomerFlowAtom,
  popupExchangeBetweenBankAccountAtom,
  popupPNCustomerFlowAtom,
  popupPNTransactionHistoryAtom,
  popupTransactionHistoryAtom
} from '../../state';
import { COMPANY_CODE } from "../../utils/Utils";
import Logo from "../logo/Logo";
import Toggle from "../sidebar/Toggle";
import User from "./dropdown/user/User";
import { POST } from "../../helper/api";
import { toast } from "react-toastify";
const { company } = getConfig();

const Header = ({ fixed, theme, className, setVisibility, ...props }) => {
  const {
    state: {
      user,
    },
  } = useUser();

  const [popupTransactionHistory, setPopupTransactionHistory] = useRecoilState(popupTransactionHistoryAtom);
  const [popupPNTransactionHistory, setPopupPNTransactionHistory] = useRecoilState(popupPNTransactionHistoryAtom);
  const [popupCustomerFlow, setPopupCustomerFlow] = useRecoilState(popupCustomerFlowAtom);
  const [popupPNCustomerFlow, setPopupPNCustomerFlow] = useRecoilState(popupPNCustomerFlowAtom);
  const [popupExchangeBetweenBankAccount, setPopupExchangeBetweenBankAccount] = useRecoilState(popupExchangeBetweenBankAccountAtom);

  const headerClass = classNames({
    "nk-header": true,
    "nk-header-fixed": fixed,
    [`is-light`]: theme === "white",
    [`is-${theme}`]: theme !== "white" && theme !== "light",
    [`${className}`]: className,
  });

  const renderActionHeader = useMemo(() => {
    if (user.username === 'yen_anh') {
      return null;
    }
    return <>
      {
        [COMPANY_CODE.TL, COMPANY_CODE.CT].includes(company) &&
        <div className="d-flex flex-gap-2">
          <Button
            className="toggle d-none d-md-inline-flex"
            color="info"
            onClick={() => {
              setPopupTransactionHistory({
                show: true,
                data: {
                  id: '',
                  type: 'IN'
                }
              })
            }}
          >
            <Icon name="plus"></Icon>
            <span>Thêm Thu</span>
          </Button>
          <Button
            className="toggle d-none d-md-inline-flex"
            color="info"
            onClick={() => {
              setPopupTransactionHistory({
                show: true,
                data: {
                  id: '',
                  type: 'OUT'
                }
              })
            }}
          >
            <Icon name="minus"></Icon>
            <span>Thêm Chi</span>
          </Button>
          <Button
            className="toggle d-none d-md-inline-flex"
            color="info"
            onClick={() => {
              setPopupCustomerFlow({
                show: true,
                data: {
                  id: '',
                  type: 'IN'
                }
              })
            }}
          >
            <Icon name="plus"></Icon>
            <span>Thêm thu KH</span>
          </Button>
          <Button
            className="toggle d-none d-md-inline-flex"
            color="info"
            onClick={() => {
              setPopupCustomerFlow({
                show: true,
                data: {
                  id: '',
                  type: 'OUT'
                }
              })
            }}
          >
            <Icon name="minus"></Icon>
            <span>Thêm chi NCC</span>
          </Button>
        </div>
      }
      {
        [COMPANY_CODE.PN].includes(company) &&
        <div className="d-flex flex-gap-2">
          <Button
            className="toggle d-none d-md-inline-flex"
            color="info"
            onClick={() => {
              setPopupPNTransactionHistory({
                show: true,
                data: {
                  id: '',
                  type: 'IN'
                }
              })
            }}
          >
            <Icon name="plus"></Icon>
            <span>Thêm Thu</span>
          </Button>
          <Button
            className="toggle d-none d-md-inline-flex"
            color="info"
            onClick={() => {
              setPopupPNTransactionHistory({
                show: true,
                data: {
                  id: '',
                  type: 'OUT'
                }
              })
            }}
          >
            <Icon name="minus"></Icon>
            <span>Thêm Chi</span>
          </Button>
          <Button
            className="toggle d-none d-md-inline-flex"
            color="info"
            onClick={() => {
              setPopupPNCustomerFlow({
                show: true,
                data: {
                  id: '',
                  type: 'IN'
                }
              })
            }}
          >
            <Icon name="plus"></Icon>
            <span>Thêm thu KH</span>
          </Button>
          <Button
            className="toggle d-none d-md-inline-flex"
            color="info"
            onClick={() => {
              setPopupPNCustomerFlow({
                show: true,
                data: {
                  id: '',
                  type: 'OUT'
                }
              })
            }}
          >
            <Icon name="minus"></Icon>
            <span>Thêm chi NCC</span>
          </Button>
        </div>
      }
    </>
  }, [user])
  return (
    <div className={headerClass}>
      <div className="container-fluid">

        <div className="nk-header-wrap">
          {renderActionHeader}
          <div className="nk-menu-trigger d-xl-none ml-n1">
            <Toggle
              className="nk-nav-toggle nk-quick-nav-icon d-xl-none ml-n1"
              icon="menu"
              click={props.sidebarToggle}
            />
          </div>
          <div className="nk-header-brand d-xl-none">
            <Logo />
          </div>
          <div className="nk-header-search ml-3 ml-xl-0">

          </div>
          <div className="nk-header-tools">
            <ul className="nk-quick-nav">
              <li className="user-dropdown" onClick={() => setVisibility(false)}>
                <User />
              </li>
            </ul>
          </div>
        </div>

      </div>
      {
        popupTransactionHistory.show
          ? <Modal style={{ width: '80vw', maxWidth: '80vw' }} isOpen={true} toggle={() => {
            setPopupTransactionHistory({
              show: false,
              data: {
                id: '',
                type: ''
              }
            })
          }}>
            <UpsertTransactionHistory onClose={() => {
              setPopupTransactionHistory({
                updatedAt: moment().valueOf(),
                show: false,
                data: {
                  id: '',
                  type: ''
                }
              })
            }} {...popupTransactionHistory.data} />
          </Modal>
          : ''
      }

      {
        popupCustomerFlow.show
          ? <Modal style={{ width: '80vw', maxWidth: '80vw' }} isOpen={true} toggle={() => {
            setPopupCustomerFlow({
              show: false,
              data: {
                id: '',
                type: ''
              }
            })
          }}>
            <AddCustomerMoneyFlow id={popupCustomerFlow.data.id} onClose={() => {
              setPopupCustomerFlow({
                updatedAt: moment().valueOf(),
                show: false,
                data: {
                  id: '',
                  type: ''
                }
              })
            }} {...popupCustomerFlow.data} />
          </Modal>
          : ''
      }

      {
        popupPNTransactionHistory.show
          ? <Modal style={{ width: '80vw', maxWidth: '80vw' }} isOpen={true} toggle={() => {
            setPopupPNTransactionHistory({
              show: false,
              data: {
                id: '',
                type: ''
              }
            })
          }}>
            <PNUpsertTransactionHistory onClose={() => {
              setPopupPNTransactionHistory({
                updatedAt: moment().valueOf(),
                show: false,
                data: {
                  id: '',
                  type: ''
                }
              })
            }} {...popupPNTransactionHistory.data} />
          </Modal>
          : ''
      }


      {
        popupPNCustomerFlow.show
          ? <Modal style={{ width: '80vw', maxWidth: '80vw' }} isOpen={true} toggle={() => {
            setPopupPNCustomerFlow({
              show: false,
              data: {
                id: '',
                type: ''
              }
            })
          }}>
            <PNAddCustomerMoneyFlow id={popupPNCustomerFlow.data.id} onClose={() => {
              setPopupPNCustomerFlow({
                updatedAt: moment().valueOf(),
                show: false,
                data: {
                  id: '',
                  type: ''
                }
              })
            }} {...popupPNCustomerFlow.data} />
          </Modal>
          : ''
      }

      {
        popupExchangeBetweenBankAccount.show
          ? <Modal size="lg" isOpen={true} toggle={() => {
            setPopupExchangeBetweenBankAccount({
              ...popupExchangeBetweenBankAccount,
              show: false,
              data: {
                id: '',
              }
            })
          }}>
            <ExchangeMoneyBetweenAccounts
              onClose={() => {
                setPopupExchangeBetweenBankAccount({
                  ...popupExchangeBetweenBankAccount,
                  updatedAt: moment().valueOf(),
                  show: false,
                  loading: false,
                  data: {
                    id: '',
                  }
                })
              }}
              {...popupExchangeBetweenBankAccount.data}
            />
          </Modal>
          : ''
      }
    </div>
  );
};
export default Header;
